import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageToBase64 from '../../components/ImageToBase64';

const ImageToBase64Page: React.FC = () => (
  <ToolLayout
    title="Image to Base64 Converter Online | AllTools"
    description="Convert images to Base64 encoded strings. Get data URL for embedding in HTML/CSS. Free converter."
    canonicalPath="/image-to-base64"
  >
    <ImageToBase64 />
  </ToolLayout>
);

export default ImageToBase64Page;
